import {gql} from "@apollo/client";

export const GET_SUBSCRIPTION_PLANS = gql`
  query GetSubscriptionPlans($planType: String) {
    subscriptionPlans(planType: $planType) {
      id
      name
      application
      isTrial
      features {
        key
        label
        level
        description
      }
      prices {
        currency
        billingCycle
        amount
        stripePriceId
      }
    }
  }
`;

export const USER_SUBSCRIPTION_INVOICES = gql`
    query UserSubscriptionInvoices($page:Int, $pageSize:Int, $planType:String) {
        userSubscriptionInvoices(page:$page, pageSize:$pageSize, planType:$planType) {
            page
            pages
            hasNext
            hasPrev
            objects {
                __typename
                ... on SubscriptionInvoiceType {
                    id
                    status
                    currency
                    amountPaid
                    amountDue
                    hostedInvoiceUrl
                    periodStart
                    subscription { plan { name application } }
                }
                ... on OrganizationSubscriptionInvoiceType {
                    id
                    status
                    currency
                    amountPaid
                    amountDue
                    hostedInvoiceUrl
                    periodStart
                    subscription { plan { name application }  }
                }
            }
        }
    }
`;
